import { MarketplaceComponentConfig } from '@nocode/types';

export default {
  name: 'StripePaymentV2',
  displayName: {
    en: 'Stripe',
    ja: 'Stripe接続',
  },
  icon: './icon.png',
  defaultWidth: 330,
  defaultHeight: 125,
  props: [
    {
      name: 'typeConnection',
      displayName: {
        en: 'Type Connection',
        ja: '接続タイプ',
      },
      type: 'text',
      default: 'anonymous',
      control: {
        type: 'menu',
        options: [
          {
            label: 'Anonymous',
            value: 'anonymous',
          },
          {
            label: 'AccountHolder',
            value: 'accountHolder',
          },
        ],
      },
    },
    {
      name: 'accountConnectId',
      displayName: {
        en: 'Account Connect ID',
        ja: 'アカウント接続ID',
      },
      type: 'text',
      default: '',
      enabled: {
        typeConnection: 'anonymous',
      },
    },
    {
      name: 'successActions',
      displayName: {
        en: 'Actions when Stripe Payment is paid successful',
        ja: '決済成功時のアクション',
      },
      type: 'action',
    },
    {
      name: 'failedActions',
      displayName: {
        en: 'Actions when Stripe Payment is paid failed',
        ja: '決済失敗時のアクション',
      },
      type: 'action',
    },
  ],
  childComponents: [
    {
      name: 'email',
      displayName: {
        en: 'Email Field',
        ja: 'メールアドレス',
      },
      props: [
        {
          name: 'emailBuyer',
          displayName: {
            en: 'Buyer email',
            ja: '購入者のメールアドレス',
          },
          type: 'text',
          default: '',
        },
      ],
    },
    {
      name: 'paymentOptions',
      displayName: {
        en: 'Payment Amount',
        ja: '支払い金額',
      },
      props: [
        {
          name: 'paymentAmount',
          displayName: {
            en: 'Payment Amount',
            ja: '支払い金額',
          },
          type: 'number',
          default: 0,
        },
        {
          name: 'typeCurrency',
          displayName: {
            en: 'Currency Type',
            ja: '通貨',
          },
          type: 'text',
          default: 'jpy',
          control: {
            type: 'menu',
            options: [
              {
                label: 'JPY',
                value: 'jpy',
              },
              {
                label: 'USD',
                value: 'usd',
              },
            ],
          },
        },
      ],
    },
    {
      name: 'changedescription',
      displayName: {
        en: 'Payment Details',
        ja: '支払い詳細',
      },
      props: [
        {
          name: 'description',
          displayName: {
            en: 'Description',
            ja: '詳細',
          },
          type: 'text',
          default: '',
        },
      ],
    },

    {
      name: 'title',
      displayName: {
        en: 'Title',
        ja: 'タイトル',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Card information',
        },
      ],
      styles: {
        fontFamily: true,
        fontSize: true,
        color: true,
      },
    },
    {
      name: 'submitButton',
      displayName: {
        en: 'Submit Button',
        ja: '送信ボタン',
      },
      // type: 'text',
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Pay Now',
        },
      ],
      styles: {
        fontFamily: true,
        fontSize: true,
        color: true,
        backgroundColor: true,
        borderRadius: true,
      },
    },
    {
      name: 'connectButton',
      displayName: {
        en: 'Connect Button',
        ja: '接続ボタン',
      },
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Connect to Stripe',
        },
      ],
      styles: {
        fontFamily: true,
        fontSize: true,
        color: true,
        backgroundColor: true,
      },
    },
    {
      name: 'disconnectButton',
      displayName: {
        en: 'Disconnect Button',
        ja: '切断ボタン',
      },
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Disconnect',
        },
      ],
      styles: {
        fontFamily: true,
        fontSize: true,
        color: true,
        backgroundColor: true,
      },
    },
  ],
} as MarketplaceComponentConfig;
